import { SET_ACTIVE_MODEL_DETAILS } from '../constants';

const initialState = {
    activeModel: {},
};

export const modelReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_ACTIVE_MODEL_DETAILS: {
            return {
                ...state,
                activeModel: action.payload,
            };
        }
        default:
            return state;
    }
};
